<template>
  <div class="personal-r">
    <h2>我的订单</h2>
    <div class="orderLists">
      <h3 class="column6">
        <span>产品名称</span>
        <span>数量</span>
        <span>应付款（元）</span>
        <span>状态</span>
        <span>交易操作</span>
        <!-- <span>发票</span> -->
      </h3>
      <ul>
        <li v-for="(item, index) in orderList" :key="index">
          <!-- <p class="th">
            <span>订单编号：{{item.id}}</span>
            <span>下单时间：{{item.orderTime | dateFormat("yyyy-MM-dd")}}</span>
            <span class="red" v-if="item.status == 0 && item.paidMoney != 0">已支付：{{item.paidMoney}}</span>
          </p> -->
          <div class="td column6">
            <span>
              <router-link :to="'/product/' + item.productId" target="_blank">{{item.orderDetailList[0].goodsName}}</router-link>
            </span>
            <span>1/{{item.stockUnit}}</span>
            <span>{{item.orderDetailList[0].payAmount}}</span>

            <!-- 状态栏 -->
            <span v-if="item.order.status == 0" class="red">未支付</span>
            <span v-else-if="item.order.status == 1">已支付</span>
            <span v-else-if="item.order.status == 4">已退款</span>
            <span v-else-if="item.order.status == 6">已关闭</span>
            <span v-else-if="item.order.status == 7">已退订</span>
            <span v-else-if="item.order.status == 14">已删除</span>
            <span v-else-if="item.order.status == 15">已失效</span>
            <span v-else>其他</span>
            <!-- 状态栏 -->

            <!-- 操作栏 -->
            <!-- <span v-if="item.status == 0 && item.isExpired == 1">已过期</span> -->
            <span v-if="item.order.status == 0">
              <router-link class="btn" :to="'/order/pay/'+item.order.id">支付</router-link>
            </span>
            <span v-else>
              <router-link class="btn-check" :to="'/order/detail/'+item.order.id">查看订单</router-link>
            </span>
            <!-- 操作栏 -->
            <!-- 电子发票 -->
            <span v-if="item.invoiceStatus == 1">
              <router-link class="btn-check" :to="'/invoice/detail/'+item.id">查看发票</router-link>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="current"
      :page-size="size"
      :total="total"
      @current-change="currentChange"
      @size-change="sizeChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: 1, //当前页
      size: 10, //每页大小
      total: 0,
      orderList: [],
      productList: [],
      productId: "",
      status: '',
      startTime: "",
      endTime: "",
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.endTime) {
            return time.getTime() > new Date(this.endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.startTime) {
            return time.getTime() < new Date(this.startTime).getTime();
          }
        }
      },
      screeningIndex: 0,
      screeningNav: ['全部','已支付','未支付'],
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {

    getOrderList() {
      var params = {
        // productId: this.productId,
        // status : this.status,
        // startTime: this.startTime,
        // endTime: this.endTime,
        current: this.current,
        size: this.size
      };
      this.$get("/order/v1/queryByPage", params)
        .then(response => {
          if (response.code === 0) {
            if(response.data) {
              this.total = response.data.total;
              this.orderList = response.data.records;   
            } else {
              this.$global.alert("没有订单数据")
            }
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    currentChange(current) {
      this.current = current;
      this.getOrderList();
      window.scrollTo(0, 0)
    },
    sizeChange(size) {
      this.size = size;
      this.getOrderList();
    },
    handleScreening(type) {
      this.screeningIndex = type;
      switch (type) {
        case 0:
          this.status = '';
          break;
        case 1:
          this.status = 1;
          break;
        case 2:
          this.status = 0
      }
      this.getOrderList();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.option-group {
  margin: 32px 0 28px;
  span {
    &.label {
      float: left;
      margin: 9px 10px 0 16px;
      @include fc(14px, #222);
    }
  }
  .button-box{
    float: left;
    display: flex;
    span{
      border-radius: 4px;
      background: #F5F5F5;
      border: 1px solid #E5E5E5;
      @include center-text(142px, 32px);
      line-height: 34px;
      font-size: 14px;
      color: #666666;
      margin-right: 20px;
      cursor: pointer;
      &.cur{
        background: #E2EDFF;
        border: 1px solid #66A1FF;
        color: #166FFF;
      }
    }
  }
  .optionList {
    border-color: #979797;
    li {
      border-bottom: 0;
      text-indent: 10px;
    }
  }
  .select {
    &:nth-of-type(1) {
      .optionList {
        width: 195px;
      }
    }
    .selected {
      span {
        @include fc(14px, #222);
      }
    }
  }
}
.select {
  float: left;
  position: relative;
  .selected {
    position: relative;
    width: 195px;
    display: block;
    @include line-height(36px);
    border: 1px solid #e5e5e5;
    cursor: pointer;
    .icon-selectBtn {
      border-left: 0;
      height: 40px;
    }
    span {
      width: 140px;
      border-right: 1px solid #e5e5e5;
      display: block;
      @include text-overflow;
      margin-left: 10px;
      padding-right: 10px;
    }
    .icon-selectBtn {
      top: -2px;
      right: 2px;
    }
    .optionList {
      top: 38px;
    }
  }
}
.orderLists {
  h3 {
    @include wh(100%, 52px);
    line-height: 52px;
    @include fc(18px, #666);
    background: #f5f5f5;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
  }
  .column6 {
    span {
      display: inline-block;
      text-align: center;
      &:first-child {
        width: 140px;
        padding-left: 20px;
        text-align: left;
      }
      &:nth-child(2) {
        width: 150px;
      }
      &:nth-child(3) {
        width: 155px;
      }
      &:nth-child(4) {
        width: 165px;
      }
      &:nth-child(5) {
        width: 160px;
      }
      &:nth-child(6) {
        width: 120px;
      }
    }
  }
  ul {
    li {
      border: 1px solid #c8ddff;
      border-radius: 2px;
      margin-bottom: 14px;
      .th {
        background: #e2edff;
        @include fc(16px, #666);
        line-height: 48px;
        span {
          margin: 28px;
        }
      }
      .td {
        padding: 30px 0;
        font-size: 18px;
        line-height: 38px;
        color: #666666;
        span {
          &.red {
            color: #ef3939;
          }
          &:first-child {
            color: #166fff;
          }
          &:nth-child(3) {
            text-align: center;
            color: #333;
          }
          .btn-check {
            @include fc(18px, #222);
            @include vertical-center(112px, 37px);
            box-sizing: border-box;
            border: 1px solid #666;
            border-radius: 18.5px;
            display: inline-block;
          }
        }
      }
    }
  }
}
.el-date-editor.el-input {
  width: 140px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/OrderList.vue